import { client } from "./client";

const ROUTES = {
  getCountries: () => `/countries/`,
};

export const countries = {
  getCountries: (auth) => {
    return client.get(ROUTES.getCountries(),auth);
  },
};
